module.exports = __webpack_public_path__ + "static/img/review.995d79ea.svg";